/* ----------------------------------------------------------------------- */
/* ------------------------------ Media Query ---------------------------- */
/* ----------------------------------------------------------------------- */
export const xss = 375;
export const xs = 420;
export const sm = 768;
export const md = 992;
export const lg = 1200;
export const xl = 1600;
export const xxl = 1920;
export const uxl = 2200;
export const fhd = 2400;
export const media = {
  xssDown: `@media (max-width: ${xss}px)`,
  xsDown: `@media (max-width: ${xs}px)`,
  smDown: `@media (max-width: ${sm}px)`,
  mdDown: `@media (max-width: ${md}px)`,
  lgDown: `@media (max-width: ${lg}px)`,
  xlDown: `@media (max-width: ${xl}px)`,
  xxlDown: `@media (max-width: ${xxl}px)`,
  xssUp: `@media (min-width: ${xss}px)`,
  xsUp: `@media (min-width: ${xs}px)`,
  smUp: `@media (min-width: ${sm}px)`,
  mdUp: `@media (min-width: ${md}px)`,
  xxlUp: `@media (min-width: ${xxl}px)`,
  lgUp: `@media (min-width: ${lg}px)`,
  xlUp: `@media (min-width: ${xl}px)`,
  uxlUp: `@media (min-width: ${uxl}px)`,
  fhdUp: `@media (min-width: ${fhd}px)`,
  xssXs: `@media (min-width: ${xss}px) and (max-width: ${xs}px)`,
  xssSm: `@media (min-width: ${xss}px) and (max-width: ${sm}px)`,
  xsSm: `@media (min-width: ${xs}px) and (max-width: ${sm}px)`,
  xsMd: `@media (min-width: ${xs}px) and (max-width: ${md}px)`,
  xsLg: `@media (min-width: ${xs}px) and (max-width: ${lg}px)`,
  xsXl: `@media (min-width: ${xs}px) and (max-width: ${xl}px)`,
  xsXxl: `@media (min-width: ${xs}px) and (max-width: ${xxl}px)`,
  xsUxl: `@media (min-width: ${xs}px) and (max-width: ${uxl}px)`,
  smMd: `@media (min-width: ${sm}px) and (max-width: ${md}px)`,
  smLg: `@media (min-width: ${sm}px) and (max-width: ${lg}px)`,
  smXl: `@media (min-width: ${sm}px) and (max-width: ${xl}px)`,
  smXxl: `@media (min-width: ${sm}px) and (max-width: ${xxl}px)`,
  mdLg: `@media (min-width: ${md}px) and (max-width: ${lg}px)`,
  mdXl: `@media (min-width: ${md}px) and (max-width: ${xl}px)`,
  mdXxl: `@media (min-width: ${md}px) and (max-width: ${xxl}px)`,
  mdUxl: `@media (min-width: ${md}px) and (max-width: ${uxl}px)`,
  lgXl: `@media (min-width: ${lg}px) and (max-width: ${xl}px)`,
  lgXxl: `@media (min-width: ${lg}px) and (max-width: ${xxl}px)`,
  xxlUxl: `@media (min-width: ${xxl}px) and (max-width: ${uxl}px)`,
  xxlFhd: `@media (min-width: ${xxl}px) and (max-width: ${fhd}px)`,
  xlUxl: `@media (min-width: ${xxl}px) and (max-width: ${xxl}px)`,
  xlXxl: `@media (min-width: ${xl}px) and (max-width: ${uxl}px)`,
  xlFhd: `@media (min-width: ${xl}px) and (max-width: ${fhd}px)`,
  uxlFhd: `@media (min-width: ${uxl}px) and (max-width: ${fhd}px)`,
};
